import { useTitle } from 'react-use';
import { connect } from 'react-redux';

import { Layout } from 'CorePackage/MainModule/components/Layout';
import { ErknmAnalytics } from 'AnalyticsPackage/ErknmAnalyticsModule/components/ErknmAnalytics';
import { getLawInterface } from 'CorePackage/MainModule/reducers/coreReducer';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { Analytics } from './Analytics';

interface IAnalyticsPageStoreProps {
  isErknm: boolean;
}

const AnalyticsPageWithoutStore = ({ isErknm }: IAnalyticsPageStoreProps) => {
  useTitle('Аналитика');

  return <Layout withFooter>{isErknm ? <ErknmAnalytics /> : <Analytics />}</Layout>;
};

const mapStateToProps = (state: IRootState): IAnalyticsPageStoreProps => ({
  isErknm: getLawInterface(state) === LawInterfacesEnum.FZ_248,
});

export const AnalyticsPage = connect(mapStateToProps)(AnalyticsPageWithoutStore);
